import React, { useEffect, useContext } from 'react';
import { CanvasContext } from 'components/upload-image/CanvasContext';
import { NO_TOOL_SELECTED } from 'constants/tools';
import BrightnessControl from './adjust/BrightnessControl';
import ContrastControl from './adjust/ContrastControl';
import SaturationControl from './adjust/SaturationControl';
import HueRotationControl from './adjust/HueRotationControl';
// import BlurControl from './adjust/BlurControl';

export default function AdjustTool({ isActive }) {
  const { pendingExitTool, setPendingExitTool, setActiveTool } =
    useContext(CanvasContext);
  useEffect(() => {
    if (pendingExitTool === 'filters') {
      setPendingExitTool(null); // reset it
      setActiveTool(NO_TOOL_SELECTED); // now safely exit
    }
  }, [pendingExitTool, setPendingExitTool, setActiveTool]);
  if (!isActive) return;
  return (
    <div className="w-full flex items-start">
      <BrightnessControl />
      &nbsp;
      <ContrastControl />
      &nbsp;
      <SaturationControl />
      &nbsp;
      <HueRotationControl />
      {/* &nbsp;
      <BlurControl /> */}
    </div>
  );
}
